export default "__VITE_ASSET__6e96c133__"